/**
 * The KPI dashboard layout endpoints (DOP-613): read the default and saved
 * order, save an arrangement, reset to the default. Null / false on failure —
 * the dashboard then keeps the server's own grouping rather than breaking.
 */

import {
	type KpiDashboardLayout,
	KpiDashboardLayoutSchema,
	type KpiSavedLayout,
} from "../types/kpiLayout";
import { apiFetch } from "../utils/apiClient";

const URL = "/api/kpi/dashboard-layout";

class KpiLayoutService {
	async get(): Promise<KpiDashboardLayout | null> {
		try {
			const resp = await apiFetch(URL);
			if (!resp.ok) return null;
			const parsed = KpiDashboardLayoutSchema.safeParse(await resp.json());
			return parsed.success ? parsed.data : null;
		} catch {
			return null;
		}
	}

	async save(layout: KpiSavedLayout): Promise<boolean> {
		try {
			const resp = await apiFetch(URL, {
				method: "PUT",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify(layout),
			});
			return resp.ok;
		} catch {
			return false;
		}
	}

	async reset(): Promise<boolean> {
		try {
			const resp = await apiFetch(URL, { method: "DELETE" });
			return resp.ok;
		} catch {
			return false;
		}
	}
}

export const kpiLayoutService = new KpiLayoutService();
